import {
  CVS_RULE,
  isBigEndianMode,
  isByteSwap,
  DATATYPE,
  ENDIAN_MODE,
} from './utils';

export function memCopy(des, offsetDes, src, offsetSrc, len) {
  const tmp = new Uint8Array(src, offsetSrc, len);
  const dtView = new DataView(des, offsetDes, len);
  for (let i = 0; i < len; i++) {
    dtView.setUint8(i, tmp[i]);
  }
}

export function memSet(des, offsetDes, val, len) {
  const dtView = new DataView(des, offsetDes);
  for (let i = 0; i < len; i++) {
    dtView.setUint8(i, val);
  }
}

export function buf2base64(buf) {
  let binary = '';
  const bytes = new Uint8Array(buf);
  const len = bytes.byteLength;
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return window.btoa(binary);
}

export function buf2str(buf, no_trim) {
  const bytes = new Uint8Array(buf);
  let str = '';
  const len = bytes.byteLength;
  if (no_trim === true) {
    for (let i = 0; i < len; i++) {
      str += String.fromCharCode(bytes[i]);
    }
  } else {
    for (let j = 0; j < len; j++) {
      if (bytes[j] === 0) break;
      str += String.fromCharCode(bytes[j]);
    }
  }

  return str;
}

export function buf2str_utf8(buf, no_trim) {
  let out, i, c;
  let char2, char3;
  out = '';
  const arr = new Uint8Array(buf);
  const len = arr.length;
  i = 0;
  while (i < len) {
    c = arr[i++];
    switch (c >> 4) {
      case 0:
        if (c === 0 && !no_trim) return out;
      // eslint-disable-next-line no-fallthrough
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
      case 6:
      case 7:
        out += String.fromCharCode(c);
        break;
      case 12:
      case 13:
        char2 = arr[i++];
        out += String.fromCharCode(((c & 0x1f) << 6) | (char2 & 0x3f));
        break;
      case 14:
        char2 = arr[i++];
        char3 = arr[i++];
        out += String.fromCharCode(
          ((c & 0x0f) << 12) | ((char2 & 0x3f) << 6) | ((char3 & 0x3f) << 0)
        );
        break;
    }
  }
  return out;
}

export function str2buf_utf8(str) {
  const len = str.length;
  const out = [];
  let p = 0;
  for (let i = 0; i < len; i++) {
    let c = str.charCodeAt(i);
    if (c < 128) {
      out[p++] = c;
    } else if (c < 2048) {
      out[p++] = (c >> 6) | 192;
      out[p++] = (c & 63) | 128;
    } else if (
      (c & 0xfc00) === 0xd800 &&
      i + 1 < str.length &&
      (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00
    ) {
      c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
      out[p++] = (c >> 18) | 240;
      out[p++] = ((c >> 12) & 63) | 128;
      out[p++] = ((c >> 6) & 63) | 128;
      out[p++] = (c & 63) | 128;
    } else {
      out[p++] = (c >> 12) | 224;
      out[p++] = ((c >> 6) & 63) | 128;
      out[p++] = (c & 63) | 128;
    }
  }
  var arr = new Uint8Array(p);
  for (var j = 0; j < p; j++) {
    arr[j] = out[j];
  }
  return arr.buffer;
}

export function buf2hex(buf) {
  const byteArray = new Uint8Array(buf);
  const hexParts = [];
  for (let i = 0; i < byteArray.length; i++) {
    const hex = byteArray[i].toString(16);
    const paddedHex = ('00' + hex).slice(-2);
    hexParts.push(paddedHex);
  }
  return hexParts.join('');
}

export function hex2buf(input) {
  const strlen = input.length / 2;
  const str_utf8 = new Uint8Array(strlen);
  if (strlen > 255) return false;
  let tmp_char;
  for (let i = 0; i < strlen; i++) {
    tmp_char = parseInt('0x' + input[2 * i] + input[2 * i + 1]);
    str_utf8[i] = tmp_char;
  }
  if (str_utf8[0] === 0) return false;
  return str_utf8.buffer;
}

function b64ToUint6(nChr) {
  return nChr > 64 && nChr < 91
    ? nChr - 65
    : nChr > 96 && nChr < 123
    ? nChr - 71
    : nChr > 47 && nChr < 58
    ? nChr + 4
    : nChr === 43
    ? 62
    : nChr === 47
    ? 63
    : 0;
}

export function decodeModbusASCIIFrame(frame) {
  let hexFrame = '';
  for (let i = 0; i < frame.length; i += 2) {
    const byte = parseInt(frame.substr(i, 2), 16);
    hexFrame += String.fromCharCode(byte);
  }
  return hexFrame;
}

export function trimModbusASCIIFrame(frame) {
  return frame.substring(2, frame.length - 4);
}

function base64Url2Arr(sBase64, nBlocksSize) {
  const sB64Enc = sBase64
    .replace(/-/g, '+')
    .replace(/_/g, '/')
    .replace(/[^A-Za-z0-9+/]/g, '');
  const nInLen = sB64Enc.length;
  const nOutLen = nBlocksSize
    ? Math.ceil(((nInLen * 3 + 1) >> 2) / nBlocksSize) * nBlocksSize
    : (nInLen * 3 + 1) >> 2;
  const taBytes = new Uint8Array(nOutLen);

  for (
    let nMod3, nMod4, nUint24 = 0, nOutIdx = 0, nInIdx = 0;
    nInIdx < nInLen;
    nInIdx++
  ) {
    nMod4 = nInIdx & 3;
    nUint24 |= b64ToUint6(sB64Enc.charCodeAt(nInIdx)) << (6 * (3 - nMod4));
    if (nMod4 === 3 || nInLen - nInIdx === 1) {
      for (nMod3 = 0; nMod3 < 3 && nOutIdx < nOutLen; nMod3++, nOutIdx++) {
        taBytes[nOutIdx] = (nUint24 >>> ((16 >>> nMod3) & 24)) & 255;
      }
      nUint24 = 0;
    }
  }

  return taBytes;
}

function uint8Arr2Hex(byteArray) {
  const hexParts = [];
  for (let i = 0; i < byteArray.length; i++) {
    const hex = byteArray[i].toString(16);
    const paddedHex = ('00' + hex).slice(-2);
    hexParts.push(paddedHex);
  }
  return hexParts.join('').toUpperCase();
}

export function base64Url2Hex(base64UrlStr) {
  return uint8Arr2Hex(base64Url2Arr(base64UrlStr));
}

function fromBase64(base64) {
  return base64.replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
}

export function hexToBase64Url(hexStr) {
  const buf = hex2buf(hexStr);
  return fromBase64(buf2base64(buf));
}

const setArrayBufferValue = {
  [DATATYPE.INT8]: 'setInt8',
  [DATATYPE.UINT8]: 'setUint8',
  [DATATYPE.INT16]: 'setInt16',
  [DATATYPE.UINT16]: 'setUint16',
  [DATATYPE.INT32]: 'setInt32',
  [DATATYPE.UINT32]: 'setUint32',
  [DATATYPE.FLOAT]: 'setFloat32',
  [DATATYPE.DOUBLE]: 'setFloat64',
};

const getArrayBufferValue = {
  [DATATYPE.INT8]: 'getInt8',
  [DATATYPE.UINT8]: 'getUint8',
  [DATATYPE.INT16]: 'getInt16',
  [DATATYPE.UINT16]: 'getUint16',
  [DATATYPE.INT32]: 'getInt32',
  [DATATYPE.UINT32]: 'getUint32',
  [DATATYPE.FLOAT]: 'getFloat32',
  [DATATYPE.DOUBLE]: 'getFloat64',
};

function initDataType(value, endianMode, dataType, byteCount) {
  let bufferLen;
  switch (dataType) {
    case DATATYPE.BIT:
    case DATATYPE.INT8:
    case DATATYPE.UINT8:
    default:
      bufferLen = 1;
      break;
    case DATATYPE.INT16:
    case DATATYPE.UINT16:
      bufferLen = 2;
      break;
    case DATATYPE.INT32:
    case DATATYPE.UINT32:
    case DATATYPE.FLOAT:
      bufferLen = 4;
      break;
    case DATATYPE.DOUBLE:
      bufferLen = 8;
  }
  const buffer = new ArrayBuffer(bufferLen);
  const view = new DataView(buffer);

  view[setArrayBufferValue[dataType]](0, value, !isBigEndianMode(endianMode));
  const _byteCount = view.buffer.byteLength;
  if (isByteSwap(endianMode) && !(_byteCount % 2)) {
    const swapped = new Uint8Array(_byteCount);
    for (let i = 0; i < _byteCount / 2; i += 1) {
      swapped[2 * i] = view.getUint8(2 * i + 1, true);
      swapped[2 * i + 1] = view.getUint8(2 * i);
    }
    return swapped.buffer;
  }
  return view.buffer;
}

export const hexStringToBytes = (hexString) => {
  // Check if the input string is empty or has an odd length
  if (hexString === '' || hexString.length % 2 !== 0) {
    throw new Error('Invalid hex string');
  }

  const bytes = [];

  for (let i = 0; i < hexString.length; i += 2) {
    const byte = parseInt(hexString.substr(i, 2), 16);
    bytes.push(byte);
  }

  return bytes;
};

export const getByteLength = (dataType) => {
  switch (dataType) {
    case DATATYPE.BIT:
    case DATATYPE.INT8:
    case DATATYPE.UINT8:
      return 1;
    case DATATYPE.INT16:
    case DATATYPE.UINT16:
    default:
      return 2;
    case DATATYPE.INT32:
    case DATATYPE.UINT32:
    case DATATYPE.FLOAT:
      return 4;
    case DATATYPE.DOUBLE:
      return 8;
  }
};

export const initBytesValue = (
  bytes,
  byteSwap,
  wordSwap,
  dwordSwap,
  dataType
) => {
  const bufferLen = getByteLength(dataType);

  const buffer = new ArrayBuffer(bufferLen);
  const view = new DataView(buffer);

  for (let i = 0; i < bufferLen; i++) {
    view.setUint8(i, bytes[i]);
  }

  const _byteCount = view.buffer.byteLength;

  if (byteSwap && !(_byteCount % 2)) {
    for (let i = 0; i < _byteCount / 2; i += 1) {
      const temp = view.getUint8(2 * i);
      view.setUint8(2 * i, view.getUint8(2 * i + 1));
      view.setUint8(2 * i + 1, temp);
    }
  }

  if (wordSwap && !(_byteCount % 4)) {
    for (let i = 0; i < _byteCount / 4; i += 1) {
      const temp = view.getUint16(4 * i);
      view.setUint16(4 * i, view.getUint16(4 * i + 2));
      view.setUint16(4 * i + 2, temp);
    }
  }

  if (dwordSwap && !(_byteCount % 8)) {
    for (let i = 0; i < _byteCount / 8; i += 1) {
      const temp = view.getUint32(8 * i);
      view.setUint32(8 * i, view.getUint32(8 * i + 4));
      view.setUint32(8 * i + 4, temp);
    }
  }

  return view.buffer;
};

export function convertEndianess(rawData, endianMode, dataType, byteCount) {
  const dataValue = parseInt('0x' + rawData, 16);
  const value = initDataType(dataValue, endianMode, dataType, byteCount);
  return new DataView(value)[getArrayBufferValue[dataType]](0);
}

export function convertEndianessFromHex(
  rawData,
  byteSwap,
  wordSwap,
  dwordSwap,
  dataType
) {
  const value = initBytesValue(
    hexStringToBytes(rawData),
    byteSwap,
    wordSwap,
    dwordSwap,
    dataType
  );
  return new DataView(value)[getArrayBufferValue[dataType]](0);
}

export function convertHexaString(hexStr, currentEndianMode, targetEndianMode) {
  if (currentEndianMode === targetEndianMode) return hexStr;
  const padlen = 4 - (hexStr.length % 4);
  if (padlen !== 4) {
    hexStr = '0'.repeat(padlen) + hexStr;
  }

  if (!(isByteSwap(currentEndianMode) ^ isByteSwap(targetEndianMode))) {
    return hexStr.split('').reverse().join('');
  }

  const strArr = hexStr.match(/.{1,2}/g);

  if (
    !(isBigEndianMode(currentEndianMode) ^ isBigEndianMode(targetEndianMode))
  ) {
    return strArr.reduce((result, curr) => {
      return (result += curr[1] + curr[0]);
    }, '');
  } else {
    return strArr.reverse().join('');
  }
}

export function convertHexaToInt(hex) {
  const byteCount = hex.length / 2;
  const finalHex = convertHexaString(
    hex,
    ENDIAN_MODE.BIG_ENDIAN_BYTESWAP,
    ENDIAN_MODE.LITTLE_ENDIAN,
    byteCount
  );
  return parseInt(finalHex, 16);
}

export function toFloat(number) {
  return parseFloat(number);
}

export function toInt(number) {
  return parseInt(number);
}

export function convertData(
  rawData,
  { rawMin, rawMax, engMin, engMax, bias, rule, ratio, offset }
) {
  let engData;
  const propotion = (engMax - engMin) / (rawMax - rawMin);
  switch (rule) {
    case CVS_RULE.NA:
    default:
      engData = rawData;
      break;
    case CVS_RULE.PROP:
      engData = rawData * propotion;
      break;
    case CVS_RULE.PROP_OFFSET:
      engData = rawData * propotion + offset;
      break;
    case CVS_RULE.RATIO_BIAS:
      engData = rawData * ratio + bias;
      break;
  }
  return engData;
}
